import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import WorkIcon from "@mui/icons-material/Work";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import SchoolIcon from "@mui/icons-material/School";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import defaultpp from "../../../images/profile.png";
import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";
import dayjs from "dayjs";

const PersonelInfo = ({ user, workingEndDate }) => {
  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: 6,
        bgcolor: "#f8fafc",
        mb: 4,
      }}
    >
      <CardContent>
        <Stack direction="row" spacing={3} alignItems="center" mb={2}>
          <Avatar
            src={defaultpp}
            alt={user.firstName}
            sx={{ width: 80, height: 80, boxShadow: 2 }}
          />
          <Box>
            <Typography variant="h5" fontWeight={700} color="primary.main">
              {user.firstName} {user.lastName}
            </Typography>
            <Stack direction="row" spacing={1} mt={1}>
              <Chip
                icon={
                  user.isActive ? (
                    <CheckCircleIcon color="success" />
                  ) : (
                    <CancelIcon color="error" />
                  )
                }
                label={user.isActive ? "Aktif" : "Pasif"}
                color={user.isActive ? "success" : "error"}
                size="small"
                sx={{ fontWeight: 600 }}
              />
              <Chip
                icon={<WorkIcon />}
                label={user.roleName}
                color="primary"
                size="small"
                sx={{ fontWeight: 600 }}
              />
            </Stack>
          </Box>
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Stack spacing={2}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <BusinessIcon color="action" />
            <Typography variant="body1" fontWeight={600}>
              Departman:
            </Typography>
            <Typography variant="body1">{user.departmentName}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <CalendarMonthIcon color="action" />
            <Typography variant="body1" fontWeight={600}>
              Başlangıç Tarihi:
            </Typography>
            <Typography variant="body1">
              {user.startDate
                ? dayjs(user.startDate).format("DD/MM/YYYY")
                : "---"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <EventAvailableIcon color={workingEndDate ? "error" : "action"} />
            <Typography variant="body1" fontWeight={600}>
              Ayrılış Tarihi:
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: workingEndDate ? "error.main" : "text.secondary" }}
            >
              {workingEndDate
                ? dayjs(workingEndDate).format("DD/MM/YYYY")
                : "---"}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PersonIcon color="action" />
            <Typography variant="body1" fontWeight={600}>
              Email:
            </Typography>
            <Typography variant="body1">{user.email || "---"}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WorkOutlineIcon color="action" />
            <Typography variant="body1" fontWeight={600}>
              Ünvan:
            </Typography>
            <Typography variant="body1">{user.title || "---"}</Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <SchoolIcon color="action" />
            <Typography variant="body1" fontWeight={600}>
              Eğitim Durumu:
            </Typography>
            <Typography variant="body1">{user.educationStatus || "---"}</Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default PersonelInfo;
